import type { z } from 'zod'
import { commonCreateDataSchema } from './common-create-data'
import { commonUpdateDataSchema } from './common-update-data'

/**
 * 資料共同欄位 - Schema
 */
export const commonDataSchema = commonCreateDataSchema.merge(
  commonUpdateDataSchema
)

/**
 * 資料共同欄位
 */
export interface CommonData extends z.infer<typeof commonDataSchema> {}
